module.exports = __webpack_public_path__ + "img/serve12.7124e97e.png";